export class Role {
    public static readonly SysAdmin = 'System Admin';
    public static readonly OrgAdmin = 'Organization Admin';
    public static readonly ClinicAdmin = 'Clinic Admin';
    public static readonly Clinician = 'Clinician';
    public static readonly Patient = 'Patient';
    public static readonly Family = 'Family';
    public static readonly Staff = 'Staff';

    // CAA and OhioUniversity
    public static readonly Participants = 'Participant';
    public static readonly CaseManager = 'Case Manager';
    public static readonly LocationAdmin = 'Location Admin';

    public static readonly Student = 'Student';
    public static readonly Counsellor = 'Counselor';
    public static readonly Mentor = ' Mentor';
    public static readonly SocialWorker = 'Social Worker';
    public static readonly CommunityPartner = 'Community Partner';

}
